import { compact } from "lodash";
import {
  CustomerType,
  CustomerPicker_CustomerCardFragment,
  CustomersFilter
} from "@graphql";
import { VirtualSelectorStore } from "../base/VirtualSelectorStore";
import { Value } from "../base/utils";
import { toGroup } from "@customers/CustomerSearch/utils";
import { SortOption } from "@search";

export type SearchFilter = {
  customerType: CustomerType | CustomerType[] | null;
  group: string[];
  customerNumber: string;
  text: string;
  includeCustomerIds: string[];
  parentId: string[];
  directParentId: string;
  sort: SortOption;
};

export const initialFilter: SearchFilter = {
  customerType: null,
  group: [],
  customerNumber: "",
  text: "",
  includeCustomerIds: [],
  parentId: [],
  directParentId: null,
  sort: "name_asc"
};

export function filterToQuery(filter: SearchFilter): CustomersFilter {
  const types = Array.isArray(filter.customerType)
    ? filter.customerType
    : [filter.customerType];
  return {
    text: filter.text,
    type: filter.customerType ? types : null,
    group: toGroup(filter.group),
    customerNumbers: compact([filter.customerNumber]),
    includeCustomerIds: filter.includeCustomerIds,
    parentId: filter.parentId,
    directParentId: filter.directParentId
  };
}

export class CustomerSelectorStore extends VirtualSelectorStore<
  SearchFilter,
  CustomerPicker_CustomerCardFragment,
  Value
> {
  get queryFilter() {
    return filterToQuery(this.filter);
  }
}
